import { APIClient } from 'services/helpers/api_helper';

import * as url from 'services/helpers/url_helper';
import { GetStoresResponse } from 'types/store/StoreTypes';

const api = new APIClient();

export const getStoresInfo = async () => {
  try {
    const response: GetStoresResponse = await api.get(url.GET_STORES_ME);
    if (response) {
      const { message, error_code, data } = response;
      if (message === 'OK' && error_code === 0) {
        return data;
      } else {
        return { stores: [] };
      }
    }
    return { stores: [] };
  } catch (error) {
    return Promise.reject(error);
  }
};
